import React, { useEffect } from "react";
import Header from "./Header";
import TaskCount from "./TaskCounts";
import TaskTable from "./TaskTable";
import Filters from "./Filters";
import { getTasks, getTaskCounts } from "../../apis/TaskApi";
import { getOpsClockData } from "../../apis/LMOpsApi";
import useTaskStore from "../../stores/TaskStore";
import { getRefreshInterval } from "../../utils/Helper";
import useContextStore from "../../stores/ContextStore";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import { useDeviceLayout } from "../common/context/DeviceLayoutContext";

const moment = require("moment-timezone");

let fetchTasksTimer = null;
let fetchTaskCountsTimer = null;

function TasksOverview() {
  /*********************
   *                   *
   *        hooks      *
   *                   *
   *********************/

  const setTasks = useTaskStore((state) => state.setTasks);
  const setTaskCounts = useTaskStore((state) => state.setTaskCounts);
  const stationTimezone = useContextStore((state) => state.stationTimezone);
  const setStationTimezone = useContextStore(
    (state) => state.setStationTimezone
  );
  const { spacingInset_shorthand3 } = useDeviceLayout();

  useEffect(() => {
    onFetchOpsClockData();
    onFetchTasks();
    return () => {
      clearInterval(fetchTasksTimer);
    };
  }, []);

  useEffect(() => {
    stationTimezone && onFetchTaskCounts();
    return () => {
      clearInterval(fetchTaskCountsTimer);
    };
  }, [stationTimezone]);

  /*********************
   *                   *
   *      handlers     *
   *                   *
   *********************/

  const onFetchOpsClockData = () => {
    if (stationTimezone !== null) return false;
    getOpsClockData(new Date().toISOString().substring(0, 10))
      .then((res) => {
        if (res.status === 200) {
          setStationTimezone(res.data.nodeTimeZone);
        } else {
          setStationTimezone(moment.tz.guess());
        }
      })
      .catch((err) => {
        setStationTimezone(moment.tz.guess());
      });
  };

  const onFetchTasks = () => {
    clearInterval(fetchTasksTimer);
    getTasksData();
    fetchTasksTimer = setInterval(() => {
      if (!document.hidden) {
        getTasksData();
      }
    }, getRefreshInterval());
  };

  const onFetchTaskCounts = () => {
    clearInterval(fetchTaskCountsTimer);
    getTaskCountsData();
    fetchTaskCountsTimer = setInterval(() => {
      if (!document.hidden) {
        getTaskCountsData();
      }
    }, getRefreshInterval());
  };

  /*********************
   *                   *
   *        api        *
   *                   *
   *********************/

  const getTasksData = () => {
    getTasks()
      .then((res) => {
        if (res.status === 200) {
          setTasks(res.data.tasks);
        } else {
          //todo Error handling
        }
      })
      .catch((err) => {
        //todo Error handling
      });
  };

  const getTaskCountsData = () => {
    const startTime = moment.tz(stationTimezone).startOf("day").unix();
    getTaskCounts(startTime)
      .then((res) => {
        if (res.status === 200) {
          setTaskCounts(res.data);
        } else {
          //todo Error handling
        }
      })
      .catch((err) => {
        //todo Error handling
      });
  };

  /*********************
   *                   *
   *      renderer     *
   *                   *
   *********************/

  return (
    <Column spacingInset={spacingInset_shorthand3}>
      <Row>
        <Header />
        <Filters />
      </Row>
      <TaskCount />
      <TaskTable />
    </Column>
  );
}

export default TasksOverview;



// WEBPACK FOOTER //
// ./src/components/overview/TasksOverview.jsx